import { render, staticRenderFns } from "./DomainCreate.vue?vue&type=template&id=04ef800b&"
import script from "./DomainCreate.vue?vue&type=script&lang=js&"
export * from "./DomainCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports